import { isAdmin, isOfficer, isCoordinator, isObserver } from "./authorities"

export const isAdminUser = defineAbility((user) => {
  return isAdmin(user)
})

export const isOfficerUser = defineAbility((user) => {
  return isOfficer(user)
})

export const isCoordinatorUser = defineAbility((user) => {
  return isCoordinator(user)
})

export const isObserverUser = defineAbility((user) => {
  return isObserver(user)
})
